import React, { useContext, useState } from "react";
import { Box } from "@material-ui/core";
import {
  NoResults,
  ActionButton,
  useDeviceTypes,
  GenericInfoPopup,
  IconName,
  Icon,
} from "halifax";
import clsx from "clsx";

import { AvailabilityNoResultsConnectorProps } from "./container";
import * as textConstants from "./textConstants";
import "./styles.scss";
import { PATH_HOME } from "../../../../utils/paths";
import { ClientContext } from "../../../../App";
// import { MobileCalendarPicker } from "../../../search/components/MobileHotelSearchControl/components";
import { trackEvent } from "../../../../api/v0/analytics/trackEvent";
import { CLEAR_ALL_FILTERS } from "redmond";
import {
  addTrackingProperties,
  useExperiments,
} from "../../../../context/experiments";

export interface IAvailabilityNoResultsProps
  extends AvailabilityNoResultsConnectorProps {}

export const AvailabilityNoResults = (props: IAvailabilityNoResultsProps) => {
  const {
    resetFilters,
    history,
    unfilteredLodgingsEmpty,
    isFilteredHotelAvailabilityLodgingsEmpty,
    setOpenDatesModal,
  } = props;
  const { matchesMobile } = useDeviceTypes();
  const { isAgentPortal } = useContext(ClientContext);
  const [isOpen, setIsOpen] = useState<boolean>(true);

  const expState = useExperiments();

  const primaryCTAHandler = unfilteredLodgingsEmpty
    ? () => setOpenDatesModal(true)
    : () => {
        resetFilters();
        trackEvent({
          eventName: CLEAR_ALL_FILTERS,
          properties: addTrackingProperties(expState.trackingProperties),
        });
      };
  const secondaryCTAHandler = unfilteredLodgingsEmpty
    ? () => history.push(PATH_HOME)
    : () => setOpenDatesModal(true);

  const buttons = [
    {
      buttonText: textConstants.RESET_BUTTON_TEXT,
      buttonWrapperClassName: clsx(
        "availability-no-results-buttons",
        "primary"
      ),
      onClick: () => {
        setIsOpen(false);
        resetFilters();

        trackEvent({
          eventName: CLEAR_ALL_FILTERS,
          properties: addTrackingProperties(expState.trackingProperties),
        });
      },
    },
    {
      buttonText: textConstants.ADJUST_DATES_BUTTON_TEXT,
      buttonWrapperClassName: clsx(
        "availability-no-results-buttons",
        "secondary"
      ),
      onClick: () => {
        setIsOpen(false);
        setOpenDatesModal(true);
      },
    },
  ];

  return matchesMobile ? (
    <Box>
      <GenericInfoPopup
        buttons={buttons}
        className={clsx("availability-no-results-root")}
        image={<Icon className="error-icon" name={IconName.ErrorState} />}
        isAgent={isAgentPortal}
        isMobile={matchesMobile}
        open={isOpen || isFilteredHotelAvailabilityLodgingsEmpty}
        subtitle={textConstants.NO_HOTELS_FILTER_SUBTITLE_TEXT}
        title={textConstants.NO_HOTELS_TITLE_TEXT}
      />
    </Box>
  ) : (
    <Box
      className={clsx("availability-no-results-root", {
        mobile: matchesMobile,
      })}
    >
      <Box className={"availability-no-results-container"}>
        <NoResults
          className="availability-no-results"
          title={textConstants.NO_HOTELS_TITLE_TEXT}
          subtitle={
            unfilteredLodgingsEmpty
              ? textConstants.NO_HOTELS_RETURNED_SUBTITLE_TEXT
              : textConstants.NO_HOTELS_FILTER_SUBTITLE_TEXT
          }
        />
        <Box className="availability-no-results-buttons">
          <ActionButton
            className="search-again-button"
            defaultStyle="h4r-primary"
            message={
              unfilteredLodgingsEmpty
                ? textConstants.ADJUST_DATES_BUTTON_TEXT
                : textConstants.RESET_BUTTON_TEXT
            }
            onClick={primaryCTAHandler}
          />
          <ActionButton
            className="reset-button"
            defaultStyle="h4r-secondary"
            message={
              unfilteredLodgingsEmpty
                ? textConstants.SEARCH_AGAIN_BUTTON_TEXT
                : textConstants.ADJUST_DATES_BUTTON_TEXT
            }
            onClick={secondaryCTAHandler}
          />
        </Box>
      </Box>
    </Box>
  );
};
